import(/* webpackMode: "eager" */ "/vercel/path0/ui/node_modules/@velocity-exchange/common/lib/clients/DlobWebsocketClient.js");
